export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getActivitySummaries: function getActivitySummaries(activityStatus) {
            return JsonRPCService.send('cc', 'claim/activity', 'getActivitySummaries', [activityStatus]);
        },

        completeActivity: function completeActivity(noteDTO) {
            return JsonRPCService.send('cc', 'claim/activity', 'completeActivity', [noteDTO]);
        },

        getActivity: function getActivity(activityID) {
            return JsonRPCService.send('cc', 'claim/activity', 'getActivity', [activityID]);
        },

        createActivityNote: function createActivityNote(activityID, noteDTO) {
            return JsonRPCService.send('cc', 'claim/activity', 'createActivityNote', [activityID, noteDTO]);
        },

        getActivityNotes: function getActivityNotes(activityId) {
            return JsonRPCService.send('cc', 'claim/activity', 'getActivityNotes', [activityId]);
        }

    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/claim/services/ActivityService.js
// module id = 1430
// module chunks = 0